import { render, staticRenderFns } from "./create-social-post-widget.vue?vue&type=template&id=7f3edf51&"
import script from "./create-social-post-widget.vue?vue&type=script&lang=js&"
export * from "./create-social-post-widget.vue?vue&type=script&lang=js&"
import style0 from "./create-social-post-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports